import axios from "axios";
import jwt_decode from "jwt-decode";
import moment from "moment";

export const getToken = () => {
  let token = localStorage.getItem("token");
  return token;
};

export const getRefreshToken = () => {
  let token = localStorage.getItem("refreshToken");
  return token;
};

export const getAxios = () => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    Authorization: ` ${token}`,
  };
  return axios.create({ headers });
};

export const getAxiosFile = () => {
  const token = getToken();
  const headers = {
    Authorization: ` ${token}`,
  };
  return axios.create({ headers });
};

export const getAxiosMultipart = () => {
  const token = getToken();
  const headers = { Authorization: `${token}` };
  return axios.create({ headers });
};

export const getUserDetails = () => {
  const token = localStorage.getItem('token');
  try {
    if(token){
      return jwt_decode(token);
    }
  } catch (error) {
    console.log('error',error);
  }
}

export const formatDate = (dateString) => {
 return dateString && moment(dateString).format("YYYY-MM-DD");
} 

//this function created by shahir hussain for show date formate dd-mm-yyyy on all view and list pages 27-08-2025
export const formatDateForView = (dateString) => {
 return dateString && moment(dateString).format("DD-MM-YYYY");
} 

export const formatDateTime = (dateString) => {
  return dateString && moment(dateString).format("DD-MM-YYYY hh:mm A");
} 

// export const formatDateForCreatedDate = (dateString) => {
//   return dateString && moment(dateString).format("DD MMM, yyyy")
// } 

export const formatDateForCreatedDate = (dateString) => {
  if (!dateString) {
    return moment().format("DD MMM, YYYY");
  }
  return moment(dateString).format("DD MMM, YYYY");
};


export const getFormattedTimestamp = () => {
  const now = new Date();
  
  // Extract date and time components
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  // Get microseconds (JavaScript only supports milliseconds)
  const milliseconds = String(now.getMilliseconds()).padStart(3, '0'); 
  const microseconds = milliseconds + "000"; // Append extra zeros for 6-digit microseconds

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${microseconds}`;
}

export const getFormattedTimestampOfDate = (dateString) => { 
  const now = new Date(dateString);
  
  // Extract date and time components
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  // Get microseconds (JavaScript only supports milliseconds)
  const milliseconds = String(now.getMilliseconds()).padStart(3, '0'); 
  const microseconds = milliseconds + "000"; // Append extra zeros for 6-digit microseconds

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${microseconds}`;
}
